import _ from 'lodash';

const addAggregateIfNotIncluded = (aggregates, aggregate) => {
  if (!aggregates.includes(aggregate)) {
    aggregates.push(aggregate);
  }
};

export const createDataFetchList = signalSets => {
  return _.map(signalSets, signalSet => {
    const assetSignalSet = _.reduce(signalSet.signals, (dataFetchSignals, signal) => {
      const existingSignal = dataFetchSignals.find(dfSignal => dfSignal.name === signal.name);

      if (existingSignal) {
        addAggregateIfNotIncluded(existingSignal.aggregates, signal.aggregate);

        if (signal.envelope) {
          addAggregateIfNotIncluded(existingSignal.aggregates, 'min');
          addAggregateIfNotIncluded(existingSignal.aggregates, 'max');
        }
      } else {
        const aggregates = signal.envelope ? [signal.aggregate, 'min', 'max'] : [signal.aggregate];
        dataFetchSignals.push({
          name: signal.name,
          type: signal.type,
          aggregates: aggregates,
          fullName: signal.fullName,
          laneNumber: signal.laneNumber,
          color: signal.color,
          decimalPoint: signal.decimalPoint
        });
      }

      return dataFetchSignals;
    }, []);

    return {
      assetId: signalSet.assetId,
      signals: assetSignalSet
    };
  });
};

